module.exports = __webpack_public_path__ + "media/question0_en.186b8d16.wav";